/* eslint-disable @typescript-eslint/no-magic-numbers */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    format: function() {
        return format;
    },
    fromMinutes: function() {
        return fromMinutes;
    },
    isValid: function() {
        return isValid;
    },
    toMinutes: function() {
        return toMinutes;
    }
});
const isValid = (str)=>{
    return str != null && /^\d*:?\d?\d?$/u.test(str);
};
const toMinutes = (str)=>{
    if (!isValid(str)) {
        return null;
    }
    const tokens = str.split(":");
    const hoursStr = tokens.length === 1 || tokens[0] === "" ? "0" : tokens[0];
    const minutesStr = tokens.length === 1 ? tokens[0] : tokens[1] === "" ? "0" : tokens[1];
    const mins = 60 * parseInt(hoursStr) + parseInt(minutesStr);
    if (Number.isNaN(mins)) {
        return null;
    }
    return mins;
};
const fromMinutes = (mins)=>{
    if (mins == null || Number.isNaN(mins) || mins < 0) {
        return null;
    }
    const hours = Math.floor(mins / 60);
    const minutes = mins % 60;
    const hoursStr = hours.toString(10).padStart(2, "0");
    const minutesStr = minutes.toString(10).padStart(2, "0");
    return "".concat(hoursStr, ":").concat(minutesStr);
};
const format = (str)=>{
    return fromMinutes(toMinutes(str));
};
const _default = {
    isValid,
    toMinutes,
    fromMinutes,
    format
};

//# sourceMappingURL=durationString.js.map